export default __webpack_public_path__ + "static/media/Twitter.473c4b94.svg";